module.exports = __webpack_public_path__ + "img/identity.c3630d24.png";